import React from 'react'
import { StudentIframePage } from '../Common/StudentIframePage'

const StudentDeadlines = () => {
	return <StudentIframePage activeMenu="Deadlines" pageName="Deadlines" linkField="deadlinelink" title="Deadlines" />
}

export { StudentDeadlines }
